module.exports = __webpack_public_path__ + "static/sierra.4690cffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients/sierra.jpg
// module id = 608
// module chunks = 208176855801404